// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d2def75a","126":"0ec5f62e","171":"c9afd99b","699":"022ce139","842":"71df8024","998":"f4a3c22e"}[chunkId] + ".chunk.js";
};